<template>
  <div class="payment" v-loading="showLoading">
    <!-- 上栏查询 -->
    <query-bar
      :query="query"
      :state="state"
      :tradeTp="tradeTp"
      :settleSt="settleSt"
      :orderSource="orderSource"
      :companyList="companys"
      :channelList="channels"
      :serviceList="services"
      :applyCustomer="applyCustomer"
      :tradeWay="tradeWay"
      @query="onClickQuery"
    />

    <!-- 数据列表 -->
    <list-data :list-data="listData">
      <template slot-scope="scope">
        <router-link
          v-if="~~scope.row.applyCustomer === 2"
          :to="`/home/factoringCurrent/details/${scope.row.id}`"
        >立即处理</router-link>
        <router-link v-else :to="`/home/factoringCurrent/details/${scope.row.id}`">查看</router-link>
      </template>
    </list-data>

    <!-- 全局组件分页 -->
    <common-page :page-data="pageData" @change="onChangePage">
      <template slot="right-aside">
        <p class="total-price margin--right">
          <span>交易金额:</span>
          <span class="color-primary">￥{{amount}}元</span>
          <span class="margin-left">清算金额:</span>
          <span class="color-primary">￥{{amountSettle}}元</span>
        </p>
        <button class="button clickable" @click="outputExcelFile">导出数据</button>
      </template>
    </common-page>
  </div>
</template>

<script>
import tools from '@/utils/tools'
import queryPage from '@/mixins/queryPage'
import QueryBar from './components/QueryBar'
import ListData from './components/ListData'

export default {
  mixins: [queryPage],
  components: {
    QueryBar,
    ListData,
  },
  data() {
    return {
      amount: 0,
      amountSettle: 0,
      tradeTp: [
        { value: '', label: '全部' },
        { value: 1, label: '即时' },
        { value: 2, label: '远期' },
      ],
      orderSource: [
        { value: '', label: '全部' },
        { value: 0, label: 'POS' },
        { value: 1, label: 'APP' },
      ],
      settleSt: [
        { value: '', label: '全部' },
        { value: -1, label: '等待清算' },
        { value: 0, label: '发起清算' },
        { value: 1, label: '清算成功' },
        { value: 2, label: '清算失败' },
      ],
      state: [
        { value: '', label: '全部' },
        { value: 0, label: '待支付' },
        { value: 1, label: '交易成功' },
        { value: 2, label: '交易失败' },
        { value: 3, label: '远期账单待确认' },
        { value: 4, label: '远期账单待退款' },
        { value: 7, label: '远期账单待结算（商户确认）' },
      ],
      applyCustomer: [
        { value: '', label: '全部' },
        { value: 1, label: '无 ' },
        { value: 2, label: '响应中' },
        { value: 3, label: '已处理' },
      ],
      tradeWay: [
        { value: '', label: '全部' },
        { value: 1, label: '额度交易' },
        { value: 2, label: '银行卡交易' },
        { value: 3, label: '余额交易' },
      ],
    }
  },

  created() {
    this.getChannelList()
    this.getCompanyList()
    this.getServiceList()
  },

  methods: {
    getListData() {
      const {
        query,
        $store: { dispatch },
        pageData: { pageSize, currentPage },
      } = this
      const dispatchEvent = 'T5/factoringCurrent/getListData'

      return dispatch(dispatchEvent, {
        ...query,
        pageSize,
        currentPage,
      }).then((data) => {
        this.listData = data[0].list
        this.pageData.total = data[0].total
        this.amount = data[1].amount || 0
        this.amountSettle = data[1].amountSettle || 0
      })
    },

    // 导出文件
    outputExcelFile() {
      const { dispatch } = this.$store

      this.showLoading = true
      dispatch('downloadFile', {
        url: '/factoring/current/export/factoring',
        params: this.query,
      }).then((data) => {
        tools.downloadFile({
          filedata: data,
          filename: `保理当前交易导出数据`,
        })
        this.showLoading = false
      })
    },
  },
}
</script>
